

/// <reference path="CoreAccounting.ts" />

// Generated class BankEntry_ManagedObject

class BankEntry_ManagedObject extends CoreAccounting
{

    // Property: amount
    set amount(value:number) {
        this.setValueForKey(value, 'amount');
    }
    get amount():number {
        return this.valueForKey('amount');
    }
    set amountPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'amount');
    }
    get amountPrimitiveValue():number {
        return this.primitiveValueForKey('amount');
    }

    // Property: balance
    set balance(value:number) {
        this.setValueForKey(value, 'balance');
    }
    get balance():number {
        return this.valueForKey('balance');
    }
    set balancePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'balance');
    }
    get balancePrimitiveValue():number {
        return this.primitiveValueForKey('balance');
    }

    // Property: concept
    set concept(value:string) {
        this.setValueForKey(value, 'concept');
    }
    get concept():string {
        return this.valueForKey('concept');
    }
    set conceptPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'concept');
    }
    get conceptPrimitiveValue():string {
        return this.primitiveValueForKey('concept');
    }

    // Property: date
    set date(value:Date) {
        this.setValueForKey(value, 'date');
    }
    get date():Date {
        return this.valueForKey('date');
    }
    set datePrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'date');
    }
    get datePrimitiveValue():Date {
        return this.primitiveValueForKey('date');
    }

    // Property: exchangeAmount
    set exchangeAmount(value:number) {
        this.setValueForKey(value, 'exchangeAmount');
    }
    get exchangeAmount():number {
        return this.valueForKey('exchangeAmount');
    }
    set exchangeAmountPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'exchangeAmount');
    }
    get exchangeAmountPrimitiveValue():number {
        return this.primitiveValueForKey('exchangeAmount');
    }

    // Property: exchangeCurrency
    set exchangeCurrency(value:string) {
        this.setValueForKey(value, 'exchangeCurrency');
    }
    get exchangeCurrency():string {
        return this.valueForKey('exchangeCurrency');
    }
    set exchangeCurrencyPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'exchangeCurrency');
    }
    get exchangeCurrencyPrimitiveValue():string {
        return this.primitiveValueForKey('exchangeCurrency');
    }

    // Property: exchangeRate
    set exchangeRate(value:number) {
        this.setValueForKey(value, 'exchangeRate');
    }
    get exchangeRate():number {
        return this.valueForKey('exchangeRate');
    }
    set exchangeRatePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'exchangeRate');
    }
    get exchangeRatePrimitiveValue():number {
        return this.primitiveValueForKey('exchangeRate');
    }

    // Property: fee
    set fee(value:number) {
        this.setValueForKey(value, 'fee');
    }
    get fee():number {
        return this.valueForKey('fee');
    }
    set feePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'fee');
    }
    get feePrimitiveValue():number {
        return this.primitiveValueForKey('fee');
    }

    // Property: orderIndex
    set orderIndex(value:number) {
        this.setValueForKey(value, 'orderIndex');
    }
    get orderIndex():number {
        return this.valueForKey('orderIndex');
    }
    set orderIndexPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'orderIndex');
    }
    get orderIndexPrimitiveValue():number {
        return this.primitiveValueForKey('orderIndex');
    }

    // Property: orderString
    set orderString(value:string) {
        this.setValueForKey(value, 'orderString');
    }
    get orderString():string {
        return this.valueForKey('orderString');
    }
    set orderStringPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'orderString');
    }
    get orderStringPrimitiveValue():string {
        return this.primitiveValueForKey('orderString');
    }

    // Property: tags
    set tags(value:string) {
        this.setValueForKey(value, 'tags');
    }
    get tags():string {
        return this.valueForKey('tags');
    }
    set tagsPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'tags');
    }
    get tagsPrimitiveValue():string {
        return this.primitiveValueForKey('tags');
    }

    // Property: type
    set type(value:number) {
        this.setValueForKey(value, 'type');
    }
    get type():number {
        return this.valueForKey('type');
    }
    set typePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'type');
    }
    get typePrimitiveValue():number {
        return this.primitiveValueForKey('type');
    }

    // Property: typeDescription
    set typeDescription(value:string) {
        this.setValueForKey(value, 'typeDescription');
    }
    get typeDescription():string {
        return this.valueForKey('typeDescription');
    }
    set typeDescriptionPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'typeDescription');
    }
    get typeDescriptionPrimitiveValue():string {
        return this.primitiveValueForKey('typeDescription');
    }

    // Property: userInfo
    set userInfo(value:any) {
        this.setValueForKey(value, 'userInfo');
    }
    get userInfo():any {
        return this.valueForKey('userInfo');
    }
    set userInfoPrimitiveValue(value:any) {
        this.setPrimitiveValueForKey(value, 'userInfo');
    }
    get userInfoPrimitiveValue():any {
        return this.primitiveValueForKey('userInfo');
    }
    // Relationship: bankAccount
    set bankAccount(value:BankAccount) {
        this.setValueForKey(value, 'bankAccount');
    }
    get bankAccount():BankAccount {
        return this.valueForKey('bankAccount') as BankAccount;
    }
}
